<div [formGroup]="searchForm">
    <div
        class="relative rounded p-4 md:p-6 mb-4 flex flex-col gap-4"
        [ngClass]="{
            'bg-white': !entity.darkMode,
            'bg-gray-800': entity.darkMode,
            'text-white': entity.darkMode,
            'text-black': !entity.darkMode,
        }">
        <div class="w-full">
            <label
                for="keywordsInput"
                class="block text-sm font-medium leading-6"
                i18n
                [ngClass]="{
                'text-gray-100': entity.darkMode,
                'text-gray-900': !entity.darkMode,
            }"
                >{{component?.filterLabels?.keywords || 'Keywords e.g. Sales manager, London'}}</label
            >
            <div class="relative mt-2">
                <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
                    <svg
                        class="h-5 w-5 text-gray-400"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        aria-hidden="true"
                        aria-label="Search icon">
                        <path
                            fill-rule="evenodd"
                            d="M9 3.5a5.5 5.5 0 100 11 5.5 5.5 0 000-11zM2 9a7 7 0 1112.452 4.391l3.328 3.329a.75.75 0 11-1.06 1.06l-3.329-3.328A7 7 0 012 9z"
                            clip-rule="evenodd" />
                    </svg>
                </div>
                <input
                    id="keywordsInput"
                    formControlName="keywords"
                    class="block w-full h-10 rounded-md border-0 p-2 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    [ngClass]="{
                        'text-gray-100 bg-transparent': entity.darkMode,
                        'text-gray-900': !entity.darkMode,
                    }" />
            </div>
        </div>

        <div class="w-full flex gap-2" *ngIf="component?.showFilters?.geo === true">
            <div class="grow">
                <label
                    for="locationInput"
                    class="block text-sm font-medium leading-6"
                    i18n
                    [ngClass]="{
                    'text-gray-100': entity.darkMode,
                    'text-gray-900': !entity.darkMode,
                }"
                    i18n
                    >Location</label
                >
                <div class="mt-2">
                    <div class="relative">
                        <input
                            id="locationInput"
                            formControlName="locationGeoSearchInput"
                            (focus)="autocompleteFocus = true"
                            (blur)="autocompleteFocus = false"
                            class="block w-full h-10 rounded-md border-0 p-2 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                            [ngClass]="{
                                'text-gray-100 bg-transparent': entity.darkMode,
                                'text-gray-900': !entity.darkMode,
                            }" />
                    </div>
                    <ul
                        *ngIf="autocompleteFocus"
                        class="max-h-72 scroll-py-2 overflow-y-auto py-2 text-sm text-gray-800 border border-gray-300 border-t-0 rounded rounded-t-none"
                        role="listbox">
                        <li
                            class="cursor-pointer px-4 py-2"
                            *ngFor="let place of places$ | async"
                            role="option"
                            tabindex="-1"
                            (mousedown)="selectResult($event, place)">
                            {{ place.properties.formatted }}
                        </li>
                        <li class="cursor-default select-none px-4 py-2" role="option" tabindex="-1">
                            No matching locations
                        </li>
                    </ul>
                </div>
            </div>
            <div>
                <label
                    for="distanceInput"
                    class="block text-sm font-medium leading-6 text-gray-900"
                    [ngClass]="{
                    'text-gray-100': entity.darkMode,
                    'text-gray-900': !entity.darkMode,
                }"
                    i18n
                    >Distance</label
                >
                <select
                    id="distanceInput"
                    formControlName="distance"
                    class="mt-2 block rounded-md border-0 h-10 p-2 pr-6 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    [ngClass]="{
                        'text-gray-100 bg-transparent': entity.darkMode,
                        'text-gray-900': !entity.darkMode,
                    }">
                    <option [value]="100">100km</option>
                    <option [value]="50">50km</option>
                    <option [value]="20">20km</option>
                    <option [value]="10">10km</option>
                    <option [value]="5">5km</option>
                </select>
            </div>
        </div>

        <div class="w-full flex-col md:flex-row flex gap-2">
            <div class="w-full md:w-1/2" *ngIf="searchMeta?.categories && component?.showFilters?.category !== false">
                <label
                    for="categoryInput"
                    class="block text-sm font-medium leading-6 text-gray-900"
                    [ngClass]="{
                        'text-gray-100': entity.darkMode,
                        'text-gray-900': !entity.darkMode,
                    }"
                    i18n
                    >{{component?.filterLabels?.category || 'Category'}}</label
                >
                <select
                    id="categoryInput"
                    formControlName="category"
                    class="mt-2 block w-full rounded-md border-0 h-10 p-2 pr-6 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    [ngClass]="{
                            'text-gray-100 bg-transparent': entity.darkMode,
                            'text-gray-900': !entity.darkMode,
                        }">
                    <option *ngFor="let term of searchMeta?.categories" [value]="term">{{ term }}</option>
                </select>
            </div>

            <div class="w-full md:w-1/2" *ngIf="searchMeta?.greenhouseLocations && component?.showFilters?.locationLabel !== false">
                <label
                    for="locationLabelInput"
                    class="block text-sm font-medium leading-6 text-gray-900"
                    [ngClass]="{
                        'text-gray-100': entity.darkMode,
                        'text-gray-900': !entity.darkMode,
                    }"
                    i18n
                    >Location</label
                >
                <select
                    id="locationLabelInput"
                    formControlName="locationLabel"
                    class="mt-2 block w-full rounded-md border-0 h-10 p-2 pr-6 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    [ngClass]="{
                            'text-gray-100 bg-transparent': entity.darkMode,
                            'text-gray-900': !entity.darkMode,
                        }">
                    <ng-container *ngFor="let office of searchMeta?.greenhouseLocations"
                        ><option
                            *ngIf="!component?.hideGreenhouseLocationLevels?.includes(office.level)"
                            [value]="office.location?.name || office.name"
                            [ngClass]="'depth-' + office.level">
                            {{ office.name }}
                        </option></ng-container
                    >
                </select>
            </div>

            <div
                class="w-full md:w-1/2"
                *ngIf="
                    !searchMeta?.greenhouseLocations &&
                    searchMeta?.locations &&
                    component?.showFilters?.location !== false
                ">
                <label
                    for="locationLabelInputGreenhouse"
                    class="block text-sm font-medium leading-6 text-gray-900"
                    [ngClass]="{
                        'text-gray-100': entity.darkMode,
                        'text-gray-900': !entity.darkMode,
                    }"
                    i18n
                    >Location</label
                >
                <select
                    id="locationLabelInputGreenhouse"
                    formControlName="locationLabel"
                    class="mt-2 block w-full rounded-md border-0 h-10 p-2 pr-6 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    [ngClass]="{
                            'text-gray-100 bg-transparent': entity.darkMode,
                            'text-gray-900': !entity.darkMode,
                        }">
                    <option value=""></option>
                    <option *ngFor="let term of searchMeta?.locations" [value]="term">{{ term }}</option>
                </select>
            </div>

            <div class="w-full md:w-1/2" *ngIf="searchMeta?.tags?.length && component?.showFilters?.hashtags !== false">
                <label
                    for="hashtagsInput"
                    class="block text-sm font-medium leading-6 text-gray-900"
                    [ngClass]="{
                    'text-gray-100': entity.darkMode,
                    'text-gray-900': !entity.darkMode,
                }"
                    i18n
                    >Hashtags</label
                >
                <select
                    id="hashtagsInput"
                    formControlName="hashtags"
                    class="mt-2 block w-full rounded-md border-0 h-10 p-2 pr-6 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    [ngClass]="{
                            'text-gray-100 bg-transparent': entity.darkMode,
                            'text-gray-900': !entity.darkMode,
                        }">
                    <option value=""></option>
                    <option *ngFor="let term of searchMeta?.tags" [value]="term">#{{ term }}</option>
                </select>
            </div>
            <div class="w-full md:w-1/2" *ngIf="searchMeta?.seniorities?.length && component?.showFilters?.seniority !== false">
                <label
                    for="seniorityTypeInput"
                    class="block text-sm font-medium leading-6 text-gray-900"
                    [ngClass]="{
                    'text-gray-100': entity.darkMode,
                    'text-gray-900': !entity.darkMode,
                }"
                    i18n
                    >Seniority</label
                >
                <select
                    id="seniorityTypeInput"
                    formControlName="seniorityType"
                    class="mt-2 block w-full rounded-md border-0 h-10 p-2 pr-6 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    [ngClass]="{
                            'text-gray-100 bg-transparent': entity.darkMode,
                            'text-gray-900': !entity.darkMode,
                        }">
                    <option value=""></option>
                    <option *ngFor="let term of seniorityTypes" [value]="term.value">{{ term.label }}</option>
                </select>
            </div>
            <div
                class="w-full md:w-1/2"
                *ngIf="searchMeta?.businessUnits?.length && component?.showFilters?.businessUnit !== false">
                <label
                    for="businessUnitInput"
                    class="block text-sm font-medium leading-6 text-gray-900"
                    [ngClass]="{
                    'text-gray-100': entity.darkMode,
                    'text-gray-900': !entity.darkMode,
                }"
                    i18n
                    >{{component?.filterLabels?.businessUnit || 'Business Unit'}}</label
                >
                <select
                    id="businessUnitInput"
                    formControlName="businessUnit"
                    class="mt-2 block w-full rounded-md border-0 h-10 p-2 pr-6 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    [ngClass]="{
                            'text-gray-100 bg-transparent': entity.darkMode,
                            'text-gray-900': !entity.darkMode,
                        }">
                    <option value=""></option>
                    <option *ngFor="let term of searchMeta?.businessUnits" [value]="term">{{ term }}</option>
                </select>
            </div>

            <div class="w-full md:w-1/2" *ngIf="component?.showFilters?.reference === true">
                <label
                    for="referenceInput"
                    class="block text-sm font-medium leading-6 text-gray-900"
                    i18n
                    [ngClass]="{
                    'text-gray-100': entity.darkMode,
                    'text-gray-900': !entity.darkMode,
                }"
                    >Job reference</label
                >
                <input
                    id="referenceInput"
                    formControlName="reference"
                    class="mt-2 block w-full rounded-md border-0 p-2 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
            </div>
        </div>

        <div class="w-full flex gap-2 justify-end">
            <button
                role="button"
                aria-label="Clear search"
                name="clear"
                class="rounded-md px-3.5 py-2.5 text-sm font-semibold shadow-sm"
                [ngClass]="{
                    'bg-transparent text-white hover:bg-white/10': entity.darkMode,
                    'bg-white hover:bg-gray-50 text-gray-900': !entity.darkMode,
                }"
                (click)="clearSearch()"
                i18n>
                Clear Search
            </button>
            <button
                role="button"
                aria-label="Search"
                name="search"
                class="inline-flex items-center gap-1 rounded-md bg-voyse px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-voyse/70"
                (click)="emitSearch()"
                i18n>
                <svg
                    class="-ml-0.5 h-5 w-5"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                    aria-label="Search icon">
                    <path
                        fill-rule="evenodd"
                        d="M9 3.5a5.5 5.5 0 100 11 5.5 5.5 0 000-11zM2 9a7 7 0 1112.452 4.391l3.328 3.329a.75.75 0 11-1.06 1.06l-3.329-3.328A7 7 0 012 9z"
                        clip-rule="evenodd" />
                </svg>
                Search
            </button>
        </div>
    </div>
</div>
